"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopTradersPeriodE = exports.TopTraderE = void 0;
var TopTraderE;
(function (TopTraderE) {
    TopTraderE[TopTraderE["SELLER"] = 0] = "SELLER";
    TopTraderE[TopTraderE["BUYER"] = 1] = "BUYER";
})(TopTraderE = exports.TopTraderE || (exports.TopTraderE = {}));
var TopTradersPeriodE;
(function (TopTradersPeriodE) {
    TopTradersPeriodE[TopTradersPeriodE["WEEK"] = 7] = "WEEK";
    TopTradersPeriodE[TopTradersPeriodE["TWO_WEEKS"] = 14] = "TWO_WEEKS";
    TopTradersPeriodE[TopTradersPeriodE["MONTH"] = 30] = "MONTH";
    TopTradersPeriodE[TopTradersPeriodE["ALL_TIME"] = 3650] = "ALL_TIME";
})(TopTradersPeriodE = exports.TopTradersPeriodE || (exports.TopTradersPeriodE = {}));
